<div class="w-full h-full">
	<div>
		<p-togglebutton
			[(ngModel)]="options.draggable!.enabled"
			onLabel="Disable"
			offLabel="Enable"
			(ngModelChange)="toggleDragable()"
		/>
	</div>
	@if(options.draggable!.enabled) {
	<div class="flex flex-col">
		@for(i of widgetList; track i) {
		<div
			draggable="true"
			(dragstart)="dragStartHandler($event, i)"
			class="flex flex-row mb-2 bg-[#F1F5F9] p-3 rounded-lg"
		>
			<div class="mr-2">
				<fa-icon
					[icon]="['fas', 'grip-vertical']"
					class="cursor-move"
				></fa-icon>
			</div>
			<div>{{ i.name }}</div>
		</div>
		}
	</div>
	}

	<gridster [options]="options" class="mt-2">
		@for (item of dashboard; track item) {
		<gridster-item [item]="item.gridsterItem">
			<app-widget
				[widget]="item"
				[edit]="options.draggable!.enabled"
				(onRemove)="removeItem($event)"
			>
			</app-widget>
		</gridster-item>
		}
	</gridster>
</div>
